// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 230) return "js/chunk.npm-async-intl-segmenter-polyfill-rs.45f47069.js";
	if (chunkId === 8772) return "js/chunk.npm-async-shiki.fc30c1ba.js";
	if (chunkId === 9141) return "js/chunk.npm-async-@shikijs.bb4318fe.js";
	if (chunkId === 421) return "js/chunk.npm-async-html2canvas.35485bb9.js";
	if (chunkId === 1006) return "js/chunk.npm-async-pdf-lib.b99951d9.js";
	if (chunkId === 2394) return "js/chunk.npm-async-@pdf-lib.2ee241fd.js";
	if (chunkId === 8385) return "js/chunk.npm-async-pako.e93062ad.js";
	if (chunkId === 4654) return "js/chunk.npm-async-jotai-devtools.a48efa18.js";
	if (chunkId === 6902) return "js/chunk.npm-async-@dotlottie.1a906df8.js";
	if (chunkId === 6215) return "js/chunk.6215.87611a40.js";
	if (chunkId === 7592) return "js/chunk.7592.8a46292b.js";
	if (chunkId === 5226) return "js/chunk.5226.50eddab1.js";
	if (chunkId === 52) return "js/chunk.52.cc65113f.js";
	if (chunkId === 944) return "js/chunk.944.99803185.js";
	if (chunkId === 3808) return "js/chunk.3808.2eea913f.js";
	if (chunkId === 6384) return "js/chunk.6384.358c21f3.js";
	if (chunkId === 8335) return "js/chunk.app-async.b631e057.js";
	if (chunkId === 170) return "js/chunk.npm-async-swr.07f55779.js";
	if (chunkId === 6351) return "js/chunk.npm-async-react-paginate.435fad6c.js";
	if (chunkId === 9465) return "js/chunk.npm-async-rxjs.4bbe69b2.js";
	if (chunkId === 448) return "js/chunk.448.33ef1380.js";
	if (chunkId === 9007) return "js/chunk.9007.bb642e59.js";
	if (chunkId === 4486) return "js/chunk.4486.1a3fd38d.js";
	if (chunkId === 5670) return "js/chunk.5670.3609bf52.js";
	if (chunkId === 6610) return "js/chunk.6610.2288db4d.js";
	if (chunkId === 7776) return "js/chunk.7776.0bd654b3.js";
	if (chunkId === 274) return "js/chunk.274.19bb674b.js";
	if (chunkId === 7442) return "js/chunk.7442.86c891d3.js";
	if (chunkId === 2418) return "js/chunk.2418.1dbbbd3f.js";
	if (chunkId === 1547) return "js/chunk.1547.172deaee.js";
	if (chunkId === 1344) return "js/chunk.1344.a8a99bfa.js";
	if (chunkId === 601) return "js/chunk.601.81cd90be.js";
	if (chunkId === 8175) return "js/chunk.8175.725f05a9.js";
	if (chunkId === 2884) return "js/chunk.2884.6291aecd.js";
	if (chunkId === 7644) return "js/chunk.7644.d3f3e257.js";
	if (chunkId === 9435) return "js/chunk.9435.3eb0cc02.js";
	if (chunkId === 3397) return "js/chunk.3397.dcf16ca0.js";
	if (chunkId === 5764) return "js/chunk.5764.7a40e236.js";
	if (chunkId === 863) return "js/chunk.863.838f4bda.js";
	if (chunkId === 6122) return "js/chunk.6122.c613e819.js";
	if (chunkId === 4581) return "js/chunk.4581.d982d69a.js";
	if (chunkId === 3749) return "js/chunk.3749.16c9b895.js";
	if (chunkId === 8487) return "js/chunk.8487.cf772750.js";
	if (chunkId === 3710) return "js/chunk.3710.33a28c9c.js";
	if (chunkId === 1800) return "js/chunk.1800.6d8b4317.js";
	if (chunkId === 1341) return "js/chunk.1341.3b264841.js";
	if (chunkId === 5423) return "js/chunk.5423.606b11fc.js";
	if (chunkId === 1352) return "js/chunk.1352.283eb0fd.js";
	if (chunkId === 6798) return "js/chunk.6798.1b77504a.js";
	if (chunkId === 8588) return "js/chunk.8588.0bb69e24.js";
	if (chunkId === 7935) return "js/chunk.7935.0af05209.js";
	if (chunkId === 9909) return "js/chunk.9909.8231c78d.js";
	if (chunkId === 4861) return "js/chunk.4861.fe5163a0.js";
	if (chunkId === 1149) return "js/chunk.1149.1725766c.js";
	if (chunkId === 101) return "js/chunk.101.69a00bf4.js";
	if (chunkId === 1762) return "js/chunk.1762.52359ddf.js";
	if (chunkId === 3941) return "js/worker.825de9dd.js";
	// return url for filenames based on template
	return undefined;
};